import { cn } from '@/lib/cn';

export function LogoMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={cn('block size-7 shrink-0', className)} aria-hidden>
      <defs>
        <linearGradient id="lumo-logo" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="oklch(0.66 0.2 280)" />
          <stop offset="1" stopColor="oklch(0.52 0.22 270)" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="9" fill="url(#lumo-logo)" />
      <rect x="8" y="8" width="10" height="10" rx="2.5" fill="#FFF1A8" />
      <rect x="14" y="14" width="10" height="10" rx="5" fill="#fff" fillOpacity=".92" />
    </svg>
  );
}

export function Logo({ className }: { className?: string }) {
  return (
    <span className={cn('inline-flex items-center gap-2 font-semibold tracking-tight text-fg', className)}>
      <LogoMark />
      <span className="text-[17px] leading-none">Lumo</span>
    </span>
  );
}
